























import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import Swiper from 'swiper';

import { Poi, PoiState } from '@/models/poi';
import PoiGalleryItems from '@/components/poi-gallery-items.vue';

@Component({
    components: {
        PoiGalleryItems,
    },
})
export default class PoiDetailFullscreenSliderPage extends Vue {

    @Prop(Number) public slideId: number;
    @Prop(String) public poiId: string;

    public poi: Poi = {} as Poi;
    public swiper: Swiper;
    public hideCaptions = false;

    get locked() {
        return this.poi.state !== PoiState.UNLOCKED;
    }

    get swiperParams() {
        return {
            zoom: {
                minRatio: 1,
                maxRatio: 5,
            }
        };
    }

    public locked_content(content: any[]) {
        if (!content || content.length === 0) return [];
        return content.slice(0, 1);
    }

    public async beforeCreate() {
        await this.$store.waitUntilReady();
        this.poi = this.$store.getPoi(parseInt(this.poiId, 10));
    }

    public mounted() {
        // @ts-ignore
        this.swiper = this.$refs.gallerySlider.swiper as Swiper;
        this.swiper.activeIndex = this.slideId;
        this.swiper.on('slideChange', this.slideChanged);
        // @ts-ignore
        this.swiper.on('tap', this.slideTapped);
    }

    @Watch('poi')
    public async updateGallery() {
        await this.$nextTick();
        // @ts-ignore
        this.$refs.gallerySlider.swiper.update();
    }

    public slideChanged() {
        this.$root.$emit('fullscreenSlideChanged', this.swiper.activeIndex);

        this.toggleSlideBasedZoom();
        this.sendSlideChangedEventToChildren();
    }

    public toggleSlideBasedZoom() {
        if (this.swiper.activeIndex < 0 || this.swiper.activeIndex >= this.swiper.slides.length) {
            return;
        }

        const currentSlide = this.swiper.slides[this.swiper.activeIndex];
        if (currentSlide && this.$$(currentSlide).hasClass('zoom-enabled')) {
            this.swiper.zoom.enable();
        } else {
            this.swiper.zoom.disable();
        }
    }

    public sendSlideChangedEventToChildren() {
        const gallerySlider = this.$refs.gallerySlider as Vue;
        for (const childComponent of gallerySlider.$children) {
            const child = childComponent as any;
            if (typeof child.onSlideChanged === 'function') {
                child.onSlideChanged();
            }
        }
    }

    public slideTapped(event: Event) {
        const tagName = (event.srcElement as any).tagName;
        if (tagName === 'P' || tagName === 'IMG') {
            this.toggleCaptionVisibility();
        }
    }

    public toggleCaptionVisibility() {
        this.hideCaptions = !this.hideCaptions;
    }

}
